import { useSchool } from '@/shared/hooks/useSchool';
import { useTitle } from '@/shared/hooks/useTitle';
import { arrayToRequestString } from '@/utils/transform';
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
} from '@vue/composition-api';
import { Dialog, Typography } from '../../parts';

export type ReactiveData = {
  organization_type_ids: number[];
  publish_types: number[];
};

export default defineComponent({
  components: { Typography, Dialog },
  setup() {
    const { setTitle } = useTitle();
    const { resetPublish } = useSchool();

    const state = reactive<ReactiveData>({
      organization_type_ids: [],
      publish_types: [],
    });

    onMounted(() => {
      setTitle({
        title: '公開情報リセット',
        icon: 'mdi-square-edit-outline',
      });
    });

    const reset = async () => {
      return resetPublish({
        organization_type_ids: arrayToRequestString(
          state.organization_type_ids,
        ),
        publish_types: arrayToRequestString(state.publish_types),
      });
    };

    const disabled = computed(
      () => !state.organization_type_ids.length || !state.publish_types.length,
    );

    return {
      state,
      reset,
      disabled,
    };
  },
});
